import React from 'react'

const ArrowRightIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='6'
    height='12'
    viewBox='0 0 6 12'
    fill='none'
    {...props}
  >
    <path
      d='M-5.39289e-08 10.0163L3.7085 6L-4.05041e-07 1.98375L1.1417 0.75L6 6L1.1417 11.25L-5.39289e-08 10.0163Z'
      fill='currentColor'
    />
  </svg>
)

export default ArrowRightIcon
